import { BitfDefaultResponseMapper } from '../default-parser';

export class BitfStrapiResponseMapper extends BitfDefaultResponseMapper {}
